import { LoaderFunctionArgs } from "react-router";

export default async function marketplaceLoader(_args: LoaderFunctionArgs) {
  return null;
}
